//#region Libraries
import { Link } from 'react-router-dom';
import styled from "styled-components";
//#endregion

export const Container = styled(Link)`
    text-decoration: none;
    padding: 15px;
    display: flex;
    flex-direction: column;
    margin: 0;
    border-radius: 8px;
    width: 168px;
    background-color: var(--light-1);
    & svg {
        fill: var(--purple-2);
    }
    &, & *:not(svg) {
        transition: 0.35s;
    }
    &:hover {
        background-color: var(--purple-2);
        & * {
            color: var(--light-1) !important;
        }
        & svg {
            fill: var(--light-1);
        }
    }
    @media (max-width: 560px) {
        width: 58vw;
    }
`;
export const TextContent = styled.div` 
    & h4 {
        font-style: normal;
        font-weight: 900;
        font-size: 14px;
        line-height: 20px;
        color: var(--purple-6);
    } 
    & p {
        font-weight: 400;
        color: var(--light-gray-5);
        font-size: 12px;
        line-height: 14px;
    }
`;

 